var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuDropdown',{attrs:{"hold-on-click":_vm.holdOnClick},scopedSlots:_vm._u([{key:"toggler",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_c('MenuDropdownContent',[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }